import { useCallback, useState } from 'react';

import { WidgetPlayground } from '../components';

/**
 * Widget Playground, create mode (CT-5190 / CT-5200).
 *
 * Owns one piece of state: the key that remounts the builder when the post-save
 * dialog's `New widget` is pressed. Remounting is what makes that reset genuine
 * — a fresh form, the stepper back on step 1, and `isDirty` false — rather than
 * a hand-written "clear every field" that drifts as fields are added.
 */
function WidgetBuilderNewPage() {
  const [builderKey, setBuilderKey] = useState(0);

  const handleNewWidget = useCallback(() => setBuilderKey((n) => n + 1), []);

  return <WidgetPlayground key={builderKey} mode="create" onNewWidget={handleNewWidget} />;
}

export default WidgetBuilderNewPage;
